import { Button } from "react-bootstrap";

function BtnRound() {
  return (
    <>
        <div className="card-body">
            <h4 className="card-title">Rounded buttons</h4>
            <p className="card-description">Add class <code>.btn-rounded</code></p>
            <div className="template-demo">
                <Button  variant="primary btn-rounded btn-fw">Primary</Button>
                <Button  variant="secondary btn-rounded btn-fw">Secondary</Button>
                <Button  variant="success btn-rounded btn-fw">Success</Button>
                <Button  variant="danger btn-rounded btn-fw">Danger</Button>
                <Button  variant="warning btn-rounded btn-fw">Warning</Button>
                <Button  variant="info btn-rounded btn-fw">Info</Button>
                <Button  variant="light btn-rounded btn-fw">Light</Button>
                <Button  variant="dark btn-rounded btn-fw">Dark</Button>
                <Button  variant="link btn-rounded btn-fw">Link</Button>
            </div>
        </div>
    </>
  )
}

export default BtnRound